import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { imageUrl } from "../../lib/api";
import { categoryLabel } from "../../data/portfolio";

const Chip = ({ children }) => <li className="rounded-full bg-slate-100 px-2.5 py-1 text-[12.5px] font-medium text-slate-700">{children}</li>;

export const ProjectCard = ({ p, headingLevel = "h3" }) => {
  const H = headingLevel;
  const chips = [p.woningtype, p.specs?.systeem, p.specs?.glas].filter((v) => v && String(v).trim());
  return (
    <li className="card card-hover group overflow-hidden" data-testid="project-card">
      <Link to={`/projecten/${p.slug}`} className="flex h-full flex-col" data-testid={`project-card-${p.slug}`}>
        <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
          <img src={imageUrl(p.hero_image?.path)} alt={p.hero_image?.alt || p.title} loading="lazy" decoding="async"
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
          {p.plaats && (
            <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-white/95 px-2.5 py-1 text-[12px] font-semibold text-ink shadow-sm">
              <MapPin className="h-3.5 w-3.5 text-maas" aria-hidden="true" /> {p.plaats}{p.year ? ` · ${p.year}` : ""}
            </span>
          )}
        </div>
        <div className="flex flex-1 flex-col p-5 sm:p-6">
          {p.categories?.length > 0 && <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-gold">{p.categories.map(categoryLabel).join(" · ")}</p>}
          <H className="mt-2 text-[18px] font-semibold leading-snug text-ink transition-colors group-hover:text-maas">{p.title}</H>
          {p.summary && <p className="mt-2 line-clamp-2 text-[14.5px] leading-relaxed text-slate-600">{p.summary}</p>}
          {chips.length > 0 && <ul className="mt-4 flex flex-wrap gap-2">{chips.map((c) => <Chip key={c}>{c}</Chip>)}</ul>}
          <span className="mt-auto inline-flex items-center gap-1.5 pt-5 text-[14px] font-semibold text-maas">
            Bekijk project <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
          </span>
        </div>
      </Link>
    </li>
  );
};
